<template>
  <form @submit.prevent="handleSearch">
    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
          <tr>
            <th class="text-center">Voter Name</th>
            <th class="text-center">Municipality</th>
            <th class="text-center">Brgy</th>
            <th class="text-center">Scanner 1</th>
            <th class="text-center">Scanner 2</th>
            <th class="text-center">Mode</th>
            <th class="text-center">Status 1</th>
            <th class="text-center">Status 2</th>
            <th class="text-center">Date</th>
          </tr>
          <tr>
            <th><input v-model="searchModel.voter_name" class="form-control" /></th>
            <th><input v-model="searchModel.city_name" class="form-control" /></th>
            <th><input v-model="searchModel.brgy_name" class="form-control" /></th>
            <th><input v-model="searchModel.scanner1_name" class="form-control" /></th>
            <th><input v-model="searchModel.scanner2_name" class="form-control" /></th>
            <th><input v-model="searchModel.mode_sl" class="form-control" /></th>
            <th><input v-model="searchModel.gift1_sl" class="form-control" /></th>
            <th><input v-model="searchModel.gift2_sl" class="form-control" /></th>
            <th><input v-model="searchModel.date_log" class="form-control" /></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in logs" :key="log.syspk_sl">
            <td>{{ log.voter_name }}</td>
            <td>{{ log.city_name }}</td>
            <td>
              {{ log.brgy_name }}
            </td>
            <td>
              {{ log.scanner1_name }}
            </td>
            <td>{{ log.scanner2_name }}</td>
            <td>{{ log.mode_sl }}</td>
            <td class="text-center">
              <i v-if="log.gift1_sl === 1" class="bi bi-check text-success fs-3"></i>
              <i v-else class="bi bi-x text-danger fs-3"></i>
            </td>
            <td class="text-center">
              <i v-if="log.gift2_sl === 1" class="bi bi-check text-success fs-3"></i>
              <i v-else class="bi bi-x text-danger fs-3"></i>
            </td>
            <td>{{ log.date_log }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <button type="submit" class="btn btn-danger d-none" />
  </form>

  <PaginationView
    v-if="logs !== null && logs.length !== 0"
    @page-change="handleChange"
    :page="searchModel.currentPage"
    :pages="searchModel.totalPages"
    :items="searchModel.totalItems"
  />
</template>
<script setup>
import PaginationView from "@/components/PaginationControl.vue";
import logService from "@/services/logService";
import spinnerService from "@/services/spinnerService";
import { onMounted, ref } from "vue";
const searchModel = ref({
  currentPage: 1,
  totalPage: 0,
  totalItems: 0,
  requestPath_log: null,
});
const paginationSearchModel = ref(null);
const logs = ref([]);
const handleChange = async (page) => {
  spinnerService.show();
  const resp = await search(page, paginationSearchModel.value);
  searchModel.value.totalItems = resp.totalItems;
  searchModel.value.currentPage = page;
  searchModel.value.totalPages = resp.totalPages;
  logs.value = resp.logs;
  spinnerService.hide();
};

const search = async (page, model) => {
  return await logService.getScannerLogs(page, model);
};

const handleSearch = async () => {
  spinnerService.show();
  paginationSearchModel.value = { ...searchModel.value };
  searchModel.value.currentPage = 1;
  const resp = await search(1, searchModel.value);
  searchModel.value.totalItems = resp.totalItems;
  searchModel.value.totalPages = resp.totalPages;
  logs.value = resp.logs;
  spinnerService.hide();
};

onMounted(() => {
  searchModel.value.currentPage = 1;
  handleSearch();
});
</script>
